import React, { useState } from 'react';
import { Card, CardBody, CardTitle, Button, Alert } from 'reactstrap';
import TutoringAgentFormWizard from '../../forms/TutoringAgentFormWizard';

const CreateTutoringAgent = () => {
  const [agentType, setAgentType] = useState(null);
  const [showWizard, setShowWizard] = useState(false);

  const handleTypeSelection = (type) => {
    setAgentType(type);
    setShowWizard(true);
  };

  const handleWizardComplete = () => {
    // Reset to type selection screen after successful creation
    setShowWizard(false);
    setAgentType(null);
  };

  const handleBackToSelection = () => {
    setShowWizard(false);
    setAgentType(null);
  };

  if (showWizard) {
    return (
      <div>
        <Button
          color="link"
          className="mb-3"
          onClick={handleBackToSelection}
        >
          <i className="bi bi-arrow-left me-2"></i>
          Back to Type Selection
        </Button>
        <TutoringAgentFormWizard
          agentType={agentType}
          onComplete={handleWizardComplete}
        />
      </div>
    );
  }

  return (
    <Card>
      <CardBody>
        <CardTitle tag="h4" className="mb-4">
          <i className="bi bi-person-plus-fill me-2"></i>
          Create New Tutoring Agent
        </CardTitle>

        <Alert color="info" className="mb-4">
          <i className="bi bi-info-circle me-2"></i>
          Select whether the tutoring agent is an individual tutor or a tutoring organization/entity.
        </Alert>

        <div className="row g-4">
          {/* Individual Tutoring Agent Card */}
          <div className="col-md-6">
            <Card
              className="h-100 shadow-sm border-2"
              style={{ cursor: 'pointer', transition: 'all 0.3s ease' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 0.5rem 1rem rgba(13, 110, 253, 0.25)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '';
              }}
              onClick={() => handleTypeSelection('individual')}
            >
              <CardBody className="text-center p-4">
                <div className="mb-3">
                  <i
                    className="bi bi-person-circle"
                    style={{ fontSize: '4rem', color: '#0d6efd' }}
                  ></i>
                </div>
                <h5 className="mb-3">Individual Tutor</h5>
                <p className="text-muted mb-3">
                  A single person providing tutoring services independently.
                </p>
                <ul className="text-start text-muted" style={{ fontSize: '0.9rem' }}>
                  <li>Personal identification required</li>
                  <li>Individual contact details</li>
                  <li>Personal bank account</li>
                  <li>Single address</li>
                </ul>
                <Button color="primary" className="mt-3 w-100">
                  Select Individual
                </Button>
              </CardBody>
            </Card>
          </div>

          {/* Entity Tutoring Agent Card */}
          <div className="col-md-6">
            <Card
              className="h-100 shadow-sm border-2"
              style={{ cursor: 'pointer', transition: 'all 0.3s ease' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 0.5rem 1rem rgba(13, 110, 253, 0.25)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '';
              }}
              onClick={() => handleTypeSelection('entity')}
            >
              <CardBody className="text-center p-4">
                <div className="mb-3">
                  <i
                    className="bi bi-building"
                    style={{ fontSize: '4rem', color: '#6610f2' }}
                  ></i>
                </div>
                <h5 className="mb-3">Tutoring Entity/Organization</h5>
                <p className="text-muted mb-3">
                  A registered company or organization providing tutoring services.
                </p>
                <ul className="text-start text-muted" style={{ fontSize: '0.9rem' }}>
                  <li>Company registration required</li>
                  <li>Organization & representative details</li>
                  <li>Business bank account</li>
                  <li>Organization & representative addresses</li>
                </ul>
                <Button color="primary" className="mt-3 w-100">
                  Select Entity
                </Button>
              </CardBody>
            </Card>
          </div>
        </div>

        <div className="mt-4 text-center text-muted">
          <p className="mb-0">
            <i className="bi bi-lightbulb me-2"></i>
            After creation, the tutoring agent will receive an email to set their password and activate their account.
          </p>
        </div>
      </CardBody>
    </Card>
  );
};

export default CreateTutoringAgent;
